
import gql from 'graphql-tag'

// """更新订单地址"""
export const updateOrderAddress = gql`
  mutation($mailingAddress: String!,$orderId: Int!, $schoolId: Int!, $areaId: Int!) {
    updateOrderAddress(
      mailingAddress: $mailingAddress
      orderId: $orderId
      schoolId: $schoolId
      areaId: $areaId
    )
  }
`

// """查询订单(经销商)"""
export const findOrder = gql`
  query($orderId: Int!) {
    findOrder(
      orderId: $orderId
    ) {
      mailingAddress
      orderNumber
      schoolId
      area {
        cityCode
        createdAt
        id
        ing
        lat
        levelType
        managers {
          createdBy {
            id
            username
          }
          modifiedBy {
            id
            username
          }
        }
        mergerName
        name
        parentId
        pinyin
        shortName
        updatedAt
        zipCode
      }
    }
  }
`

// 查询学校
export const findSchools = gql`
  query($order: [SchoolsFindOrder!], $paging: PagingQuery, $where: SchoolsFindFilter) {
    findSchools(
      order: $order,
      paging: $paging,
      where: $where,
    ) {
      schools {
        id
        name
      } 
    }
  }
`
